
import Component from '../../../assets/scripts/modules/component'
import SwiperWrapper from '../../../assets/scripts/modules/swiper-wrapper'

const SWIPER_OPTIONS = {
  loop: false,
  slidesPerView: 1,
  spaceBetween: 15,
  grabCursor: false,
  breakpoints: {
    530: { slidesPerView: 2 },
    800: { slidesPerView: 3 },
    1180: { slidesPerView: 4 },
    1580: { slidesPerView: 4 },
    2240: { slidesPerView: 4 }
  }
}

const clampNumber = (value, min, max) => Math.max(min, Math.min(max, value))
const BREAKPOINT = 1480

export default class CardCarouselComponent extends Component {
  async init () {
    this.initSwiper()
    this.initParallax()
  }

  initSwiper () {
    this.container = this.element.querySelector('.card-carousel__swiper-container')

    if (!this.container) {
      return
    }

    this.loadSwiper()
  }

  loadSwiper () {
    const options = { ...SWIPER_OPTIONS }
    this.swiperWrapper = new SwiperWrapper(this.container, options)
  }

  initParallax () {
    this.title = this.element.querySelector('.card-carousel__highlight-title')
    this.offset = null

    if (!this.title) {
      return
    }

    window.addEventListener('scroll', () => this.updateParallax(), { passive: true })
    window.addEventListener('resize', () => this.updateParallax(), { passive: true })
    this.updateParallax()
  }

  updateParallax () {
    if (window.innerWidth < BREAKPOINT) {
      this.title.style.transform = 'translate3d(0, 0, 0)'
      return
    }

    const rect = this.element.getBoundingClientRect()
    const height = this.title.offsetHeight

    const centerlineOffset = rect.top + (height / 2) - (window.innerHeight / 2)
    const clampLimit = (window.innerHeight / 2) + (height * 2)
    const clampedOffset = clampNumber(centerlineOffset, -clampLimit, clampLimit)
    const adjustedOffset = (clampedOffset / 4) + 'px'

    if (adjustedOffset !== this.offset) {
      this.title.style.transform = `translate3d(0, calc(-50% - ${adjustedOffset}), 0)`
    }

    this.offset = adjustedOffset
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.card-carousel').forEach(element => {
  element.instance = element.instance || new CardCarouselComponent(element)
}))
